import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.clickHandler = this.closeMenu.bind(this)
    document.addEventListener("click", this.clickHandler)
    document.addEventListener("turbo:before-visit", () => this.hide())
  }

  disconnect() {
    document.removeEventListener("click", this.clickHandler)
    document.removeEventListener("turbo:before-visit", () => this.hide())
  }

  toggle(event) {
    if (this.menuTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.menuTarget.classList.remove("hidden")

    requestAnimationFrame(() => {
      this.menuTarget.classList.remove("opacity-0", "translate-y-1")
      this.menuTarget.classList.add("opacity-100", "translate-y-0")
    })
  }

  hide() {
    this.menuTarget.classList.remove("opacity-100", "translate-y-0")
    this.menuTarget.classList.add("opacity-0", "translate-y-1")

    setTimeout(() => {
      this.menuTarget.classList.add("hidden")
    }, 150)
  }

  closeMenu(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}
